import { computed } from '@nuxtjs/composition-api';
import type { Product, ProductAttributes } from '@wemade-vsf/catalog/lib/runtime/product/types';

const packageSizeAtt = 'wm_package_content';
const packageUnitAtt = 'wm_package_unit';

function generateProductAttributes(product: Product) {
  let atts = {};
  if (product.wm_custom_attributes?.length) {
    product.wm_custom_attributes.forEach(att => {
      atts[att.attribute_code] = att
    });
  }
  return atts;
}

export function usePackagingUnit(atts: { product?: Product, attributes?: ProductAttributes }) {
  const { product, attributes } = atts;

  const productAttributes = product 
    ? generateProductAttributes(product)
    : attributes;

  const packageSize = computed<number>(() => {
    const att = productAttributes[packageSizeAtt];
    if (att) {
      return parseInt(att.value);
    }
    return 0;
  });
  
  const packageUnit = computed(() => productAttributes[packageUnitAtt]);
  const packageUnitLabel = computed<string>(() => productAttributes[packageSizeAtt]?.attribute_label ?? '')

  const getPackageUnit = (multiple: boolean = true): string => {
    if (packageUnit.value) {
      const unit = packageUnit.value.value;
      if (unit.indexOf('/') > -1) {
        const [multi, singular] = unit.split('/');
        return multiple ? multi : singular;
      }
      return unit;
    }
    return '';
  }

  const getPricePerUnit = (price: number): number => {
    const size = packageSize.value;
    if (!size) return price;
    return price / size;
  }

  return {
    packageSize,
    packageUnitLabel,
    getPackageUnit,
    getPricePerUnit
  }
}